import angular from 'angular'
import template from './template.html'

function NominasSharedEmpleadoAgregarComponent($dialogParams, dialog) {
  let $ctrl = this;

  $ctrl.cancelado = cancelado;
  $ctrl.creado = creado;
  $ctrl.data = undefined;
  $ctrl.idEmpresa = $dialogParams.idEmpresa;
  $ctrl.empresa = $dialogParams.empresa;

  function creado() {
    $ctrl.data = {
      Empleado: $ctrl.data.Empleado,
      Empresa: $ctrl.data.empresa,
      ID_Empleado: $ctrl.data.ID_Empleado,
      ID_Empresa: $ctrl.data.ID_Empresa,
      Nombre: $ctrl.data.nombre,
      Status: $ctrl.data.status,

    };

    dialog.resolve($ctrl.data);
  }

  function cancelado() {
    dialog.reject();
  }
}

angular.module('nominas.shared')
  .controller('NominasSharedEmpleadoAgregar', NominasSharedEmpleadoAgregarComponent)
  .config(($dialogProvider) => {
    $dialogProvider.dialog('empleado.agregar', {
      controller: 'NominasSharedEmpleadoAgregar',
      template: template,
      controllerAs: '$ctrl',
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/shared/components/empleado/agregar/component.js